import { LineReveal, FadeUp } from "./Reveal";

export default function PageHeader({ eyebrow, title, description, meta }) {
  const titleLines = Array.isArray(title) ? title : [title];
  return (
    <section className="pt-36 md:pt-44 pb-16 md:pb-24 border-b border-[var(--line)]" data-testid="page-header">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-2">
            <p className="eyebrow-gold">{eyebrow}</p>
          </div>
          <div className="md:col-span-8">
            <LineReveal
              as="h1"
              lines={titleLines}
              className="h-display text-[clamp(3rem,7.5vw,7rem)] text-[var(--navy)]"
            />
            {description && (
              <FadeUp delay={0.4} className="mt-8 max-w-2xl text-[var(--steel)] text-lg leading-relaxed">
                {description}
              </FadeUp>
            )}
          </div>
          {meta && (
            <FadeUp delay={0.5} className="md:col-span-2 text-right eyebrow text-[var(--muted-foreground)]">
              {meta}
            </FadeUp>
          )}
        </div>
      </div>
    </section>
  );
}
